// Angular
import { Component, OnInit, OnDestroy, ViewEncapsulation } from '@angular/core';

// NGRX
import { Observable } from 'rxjs';
import { take } from 'rxjs/operators';
import { Store, select } from '@ngrx/store';

// OLCI
import { Guest } from '../../../models';
import * as fromRoot from '../../../reducers';
import { slideInDownAnimation } from '../../../animation';
import { LoaderService } from '../../loading/loader.service';
import * as guestActions from '../../../actions/guest.actions';
import { GuestService } from '../../core/services/guest.service';
import { BookingService } from '../../core/services/booking.service';
import { ResourceBundleService } from '../../core/services/resource-bundle.service';

@Component({
    selector: 'app-landing-page-container',
    templateUrl: './landing-page.container.html',
    animations: [slideInDownAnimation],
    encapsulation: ViewEncapsulation.None,
    standalone: false
})
export class LandingBackContainerComponent implements OnInit, OnDestroy {
	// Model retrieved from store, to be propagated to child components
	public guestsCompleted: Guest[];
	public guestsCompleted$: Observable<Guest[]>;
	public guestsNotCompleted$: Observable<Guest[]>;
	public language$: Observable<any>;
	public loggedInGuest$: Observable<any>;
	public selectedGuests$: Observable<Guest[]>;
	public session$: Observable<any>;
	public isAnyGuestLocked = false;
	public screensize$: Observable<any>;
	public arrivalTimeAlert = '';
	public checkInGuestSelectBanner: Observable<boolean>;
	public checkInEntryInterrupt$: Observable<boolean>;

	// Used for dynamic DOM modification
	public bodyTag: any;

	public constructor(
		private readonly store: Store<fromRoot.AppState>,
		public guestService: GuestService,
		public loaderService: LoaderService,
		public resourceBundle: ResourceBundleService,
		public bookingService: BookingService
	) {
		// Map store elements to class attributes
		this.language$ = this.store.pipe(select(fromRoot.getCurrentlanguage));
		this.guestsNotCompleted$ = this.store.pipe(select(fromRoot.getGuestListNotCompleted));
		this.selectedGuests$ = this.store.pipe(select(fromRoot.getSelectdGuestsForCheckinProcess));
		this.session$ = this.store.pipe(select(fromRoot.getSessionVar));
		this.guestsCompleted$ = this.store.pipe(select(fromRoot.getGuestListCompleted));
		this.screensize$ = this.store.pipe(select(fromRoot.getContentScreenSize));
		this.checkInEntryInterrupt$ = this.store.pipe(select(fromRoot.getCheckinEntryInterrupt));
		this.checkInGuestSelectBanner = this.store.pipe(select(fromRoot.getCheckInGuestSelectBanner));
	}

	public ngOnInit() {
		this.loaderService.hideLoader();
		this.isAnyGuestLocked = this.guestService.isAnyGuestLocked();
		this.arrivalTimeAlert = this.bookingService.getArrivalTimeEmptyInventoryAlert();
		this.guestService.resetSelectedGuestState();
		this.store.pipe(select(fromRoot.getGuestListCompleted), take(1)).subscribe((completed) => {
			this.guestsCompleted = completed;
		});

		this.store.dispatch(new guestActions.ResetGuestsSelectedForCheckinAction(this.guestsCompleted));

		window.scrollTo(0, 0);
		this.bodyTag = document.body;
		this.bodyTag.classList.add('big-header');
	}

	public ngOnDestroy() {
		if (this.bodyTag) {
			this.bodyTag.classList.remove('big-header');
		}
	}
}
